'use strict';
var timerId = null;
var mouseouttimerId = null;
var limouseouttimerId = null;

var mbga4 = function () {
    var brandName = 'Mario Badescu';
    var useGtm = false;

    return {
        addImpression: function(categoryName, categoryId, items) {

            if (!useGtm) {
                if (typeof gtag === "undefined" || !gtag) {
                    return;
                }

                gtag('event', 'view_item_list', {
                    'items': [
                        {
                            'item_id': id, // Product ID (string).
                            'item_name': name, // Product name (string).
                            'item_category': category, // Product category (string).
                            'item_brand': brandName, // Product brand (string).
                            'item_variant': variant, // Product variant (string).
                            'position': position, // Product position (number).,
                            'currency': 'USD'
                        }
                    ]
                });
            }
            else {

                dataLayer.push({
                    'event': 'view_item_list',
                    'ecommerce': {
                        'item_list_id': categoryId, 
                        'item_list_name': categoryName, 
                        'currency': 'USD',                       // Local currency is optional.
                        'items': items
                    }
                });
            }
            //console.log('Added impression ' + id);
        },
        addProductToCart: function (id, name, category, price, variant, qty, sku) {
            if (!useGtm) {
                if (typeof gtag === "undefined" || !gtag) {
                    return;
                }

                gtag('event', 'add_to_cart', {
                    currency: 'USD',
                    items: [{
                        item_id: sku,
                        item_name: name,
                        item_category: category,
                        item_brand: brandName,
                        item_variant: variant,
                        currency: 'USD',
                        price: price,
                        quantity: qty
                    }],
                });
            }
            else {
                window.dataLayer = window.dataLayer || [];

                window.dataLayer.push({
                    'event': 'add_to_cart',
                    'currency': 'USD',
                    'ecommerce': {
                        'items': [{
                            'item_id': sku,
                            'item_name': name,
                            'item_category': category,
                            'item_brand': brandName,
                            'item_variant': variant,
                            'price': price,
                            'quantity': qty,
                            'currency': 'USD'
                        }]
                    }
                });
            }
            //console.log('Added to cart ' + sku);

            //mbfb.addToCart(sku, price, qty);

            //fbq('track', 'AddToCart', {
            //    content_ids: [sku],
            //    content_type: 'product',
            //    value: price * qty,
            //    currency: 'USD',
            //    contents: [{ 'id': sku, 'quantity': qty, 'item_price': price }]
            //});
        },
        removeFromCart: function (products) {
            if (!useGtm) {
                if (typeof gtag === "undefined" || !gtag) {
                    return;
                }
                for (var i = 0; i < products.length; i++) {
                    var product = products[i];

                    gtag('event', 'remove_from_cart', {
                        'currency' : 'USD',
                        "items": [
                            {
                                "item_id": product.sku,
                                "item_name": product.name,
                                "price": product.price,
                                "item_brand": brandName,
                                "item_category": product.categoryName,
                                "item_variant": product.size,
                                "quantity": product.quantity,
                                "currency" : 'USD'
                            }
                        ]
                    });
                }
            }
            else {

                window.dataLayer = window.dataLayer || [];

                var gtmProducts = [];

                for (var i = 0; i < products.length; i++) {
                    gtmProducts.push({                          //  removing a product to a shopping cart.
                        "item_id": products[i].sku,
                        "item_name": products[i].name,
                        "price": products[i].price,
                        "item_brand": brandName,
                        "item_category": products[i].categoryName,
                        "item_variant": products[i].size,
                        "quantity": products[i].quantity,
                        "currency" : 'USD'
                    });
                }

                window.dataLayer.push({
                    'event': 'remove_from_cart',
                    'ecommerce': {
                        'currency' : 'USD',
                        'items': gtmProducts
                    }
                });
            }
        },
        addShippingInfo: function(shippingMethod){
            if (!useGtm) {
                if (typeof gtag === "undefined" || !gtag) {
                    return;
                }

                gtag('event', 'add_shipping_info', {
                    "currency": 'USD',
                    "shipping_tier": shippingMethod,
                });
            }
            else {
                
                    dataLayer.push({
                        'event': 'add_shipping_info',
                        'ecommerce': {
                            'currency': 'USD',
                            'shipping_tier': shippingMethod,
                        }
                    });
                }
        },
        addPaymentInfo: function(paymentType){
            if (!useGtm) {
                if (typeof gtag === "undefined" || !gtag) {
                    return;
                }

                gtag('event', 'add_payment_info', {
                    "currency": 'USD',
                    'payment_type': paymentType,
                });
            }
            else {

                dataLayer.push({
                    'event': 'add_payment_info',
                    'ecommerce': {
                        'currency': 'USD',
                        'payment_type': paymentType,
                    }
                });
            }
        },
        checkoutPage: function (products, step) {
            if (!useGtm) {
                if (typeof gtag === "undefined" || !gtag) {
                    return;
                }
                var gtagProducts = [];
                
                for (var i = 0; i < products.length; i++) {
                    gtagProducts.push({
                        "item_id": product.sku,
                        "item_name": product.name,
                        "price": product.price,
                        "item_brand": brandName,
                        "item_category": product.categoryName,
                        "item_variant": product.size,
                        "quantity": product.quantity,
                        "currency": "USD",
                    });
                    
                    //console.log('Checkout page ' + product.sku);
                }

                gtag('event', 'begin_checkout', {
                    "items": gtagProducts,
                    "step": step
                });
            }
            else {
                var gtmProducts = [];

                for (var i = 0; i < products.length; i++) {
                    var product = products[i];
                    gtmProducts.push({
                        "item_id": product.sku,
                        "item_name": product.name,
                        "price": product.price,
                        "item_brand": brandName,
                        "item_category": product.categoryName,
                        "item_variant": product.size,
                        "quantity": product.quantity,
                        "currency": "USD",
                    });
                }

                dataLayer.push({
                    'event': 'begin_checkout',
                    'ecommerce': {
                        'items': gtmProducts
                    }
                });
            }
            //if (step === 1) {
                //mbfb.initiateCheckout();
            //}
        },
        search: function (productId, productName, category) {
            if (!useGtm) {
                if (typeof gtag === "undefined" || !gtag) {
                    return;
                }
               
                gtag('event', 'add_to_cart', {
                    currency: 'USD',
                    items: [{
                        item_id: productId,
                        item_name: productName,
                        item_category: category,
                    }],
                });

                gtag('event', 'click', {       // click action.
                    'list': 'Search Autocomplete'          // Product list (string).
                });
            }

        },
        searchPage: function (query, gaTrackingId) {
            if (!useGtm) {
                if (typeof gtag === "undefined" || !gtag) {
                    return;
                }
                gtag('config', gaTrackingId, {
                    'page_path': '/search/' + query
                });
            }
            else {
                dataLayer.push({
                    event: 'pageview',
                    page: {
                        path: '/search/' + query,
                        title: 'Search'
                    }
                });
            }
            //mbfb.search(query);
        },
        addProductImpression : function(product, category, sizeId) {
            if (!category) {
                category = product.category;
            }

            let size = '';
            let sku = '';

            if (!sizeId) {
                sizeId = getSizeIdFromFormByProduct(product);
            }

            if (product.sizes && product.sizes.length > 0) {
                if (sizeId) {
                    for (let i = 0; i < product.sizes.length; i++) {
                        if (product.sizes[i].id == sizeId) {
                            sku = product.sizes[i].sku;
                            size = product.sizes[i].size;

                            if (!size) {
                                size = product.sizes[i].name + product.sizes[i].measure;
                            }
                        }
                    }
                }
                else {
                    size = product.sizes[0].size;

                    if (!size) {
                        size = product.sizes[0].name + product.sizes[0].measure;
                    }

                    sku = product.sizes[0].sku;
                }
            }



            this.addImpression(sku === '' ? product.id : sku, product.name, category, size, product.position);
        },
        addProductsImpression: function (products) {
            for (var i=0;i<products.length;i++) {
                var size = '';
                var product = products[i];
                if (product.sizes && product.sizes.length > 0) {
                    size = product.sizes[0].size;

                    if (!product.sku) {
                        product.sku = product.sizes[0].sku;
                    }
                }

                this.addImpression(product.sku, product.name, product.categoryName, size, i);
            }
        },
        //purchase: function (products, order) {
        //    if (!ga) {
        //        return;
        //    }
        //    for (var i = 0; i < products.length; i++) {
        //        ga('ec:addProduct', {
        //            'id': products[i].id,
        //            'name': products[i].name,
        //            'category': products[i].category,
        //            'brand': brandName,
        //            'variant': products[i].variant,
        //            'price': products[i].price,
        //            'quantity': products[i].qty
        //        });
        //    }
        //    ga("ec:setAction", "purchase", {
        //        "id": order.Id,
        //        "affiliation": "Online Store",
        //        "revenue": order.total,
        //        "tax": order.tax,
        //        "shipping": order.shipping
        //    });
        //},
        details: function (id, name, category, price) {

            if (!useGtm) {
                if (typeof ga === "undefined" || !ga) {
                    return;
                }
                gtag('event', 'view_item', {
                    'currency': 'USD',
                    'items': [
                        {
                            'item_id': id, // Product ID (string).
                            'item_name': name, // Product name (string).
                            'item_category': category, // Product category (string).
                            'item_brand': brandName, // Product brand (string).
                            'item_variant': '', // Product variant (string).
                            'price': price, // Product position (number).,
                            'currency': 'USD'
                        }]
                });
                
            } else {
                dataLayer.push({
                    'event' : 'view_item',
                    'ecommerce': {
                        'currency': 'USD',
                        'items': [
                            {
                                'item_id': id, // Product ID (string).
                                'item_name': name, // Product name (string).
                                'item_category': category, // Product category (string).
                                'item_brand': brandName, // Product brand (string).
                                'item_variant': '', // Product variant (string).
                                'price': price, // Product position (number).,
                                'currency': 'USD'
                            }
                        ]
                        }
                });
            }
            //console.log('Added details ' + id);
        },

        productDetails: function (product, img) {
            let price = '';
            let sku = '';

            let sizeId = getSizeIdFromFormByProduct(product);

            if (product.sizes && product.sizes.length > 0) {
                if (sizeId) {
                    for (let i = 0; i < product.sizes.length; i++) {
                        if (product.sizes[i].id == sizeId) {
                            sku = product.sizes[i].sku;
                            price = product.sizes[i].price;
                        }
                    }
                }
                else {
                    price = product.sizes[0].price;
                    sku = product.sizes[0].sku;
                }
            }

            this.details(sku === '' ? product.id : sku, product.name, product.categoryName, price);
            mbklaviyo.details(product, sku === '' ? product.id : sku, price, img);
        },

        sendPageView: function () {
            return;
            //Because it's permanently "true"
        },
        selectFilter: function (label, value) {
            if (!useGtm) {
                if (typeof gtag === "undefined" || !gtag) {
                    return;
                }

                const cat = label.substring(label.lastIndexOf(".")+1);
                console.log(cat + ' ' + value);
              
                gtag('event', 'Filter', {
                    'event_category': cat,
                    'event_label': value,
                    'value': value,
                });
            }
            else {
                dataLayer.push({
                    'event': 'Filter',
                    'type': 'Select',
                    'label': label,
                    'value': value
                });
            }
        },

        buttonClicked: function (event, label, value) {
            if (!useGtm) {
                if (typeof gtag === "undefined" || !gtag) {
                    return;
                }

                gtag('event', 'click', {
                    'event_category': event,
                    'event_label': label,
                    'value': value,
                });
            }
            else {
                dataLayer.push({
                    'event': event,
                    'type': 'Click',
                    'label': label,
                    'value': value
                });
            }
        },

        customEvent: function (category, action, label, value, nonInt = 'True') {
            if (!useGtm) {
                if (typeof gtag === "undefined" || !gtag) {
                    return;
                }
                
                gtag('event', action, {
                    'event_category': category,
                    'event_label': label,
                    'value': value,
                });
            }
            else {
                dataLayer.push({
                    'event': 'CustomGAEvent',
                    'category': category,
                    'action': action,
                    'label': label,
                    'value': value
                    //'nonInt': nonInt
                });

                //console.log(action + ' ' + label);
            }
        },

        mainMenuEvent: function (action, label) {
            //console.log(action + ' ' + label);
            this.customEvent('Main Menu', action, label, 1);
        },

        homePageEvent: function (action, label) {
            //console.log(action + ' ' + label);
            this.customEvent('Homepage', action, label, 1);
        },

        productPageEvent: function (action, label) {
            //console.log(action + ' ' + label);
            this.customEvent('PDP', action, label, 1);
        },

        cartButtonnClicked: function (label, value) {
            this.buttonClicked('CartButtonClicked', label, value);
        },

        categoryListing: function (category, items) {
            if (!useGtm) {
                if (typeof gtag === "undefined" || !gtag) {
                    return;
                }

                gtag('event', 'category_page', {
                    'category': category,
                    'items_skus': items
                });
                
            }
            else {
                dataLayer.push({
                    'event': 'category_page',
                    'item_category': category,
                    'items_skus': items
                });

                //console.log(action + ' ' + label);
            }
        },
        trackFooterSignUpForm: function () {
            gtag('event', 'form_submit', {'form': 'MB form', 'form_id': 'Footer Form'});
          console.log('MB form');
        },
    }
}();

function setTooltipForOwl() {
    $(document).mousemove(function () {
        $('.products-widget .owl-item').each(function () {
            var position = $(this).offset().left - $(window).scrollLeft();
            if (position > 930) {
                $('.dialog-bubble', this).addClass('flippedtext');
            } else {
                $('.dialog-bubble', this).removeClass('flippedtext');
            }
        });
    });
}

function eventregisterfirst(eventid) {
    if ($(window).width() < 600)
        $.colorbox({ html: $('.event-register-form').html(), width: 300 });
    else
        $.colorbox({ html: $('.event-register-form').html(), width: 550 });
    $('.presseventid').val(eventid);
}


function eventregisterloggedin(eventid) {
    $(".eventrgsbtnlogged[rel='" + eventid + "']").text('Registering..');
    $.post("events/register", { eventid: eventid }, function () {
        $(".eventrgsbtnlogged[rel='" + eventid + "']").replaceWith(function () {
            return $("<span>Registered</span>");
        });
    });
}
function eventaddtofav(eventid) {
    $(".addtofav[rel='" + eventid + "']").text('Loading..');
    $.post("events/addtofav", { eventid: eventid }, function () {
        $(".addtofav[rel='" + eventid + "']").replaceWith(function () {
            return $("<span>Favorite</span>");
        });
    });
}


var locationCheck = {

    codeLoaded: function() {
        if (window.localStorage !== null) {
            if (localStorage.getItem('continentCode') !== 'undefined') {
                return localStorage.getItem('continentCode');
            }
        }
        return false;
    },
    saveItem: function(name, value) {
        if (window.localStorage !== null) {
            localStorage.setItem(name, value);
        }

    },

    getContinentCode: function() {
        if (this.codeLoaded()) {
            return this.codeLoaded()
        } else {
            if (/2.+/.test(geoplugin_status())) {
                var continent = geoplugin_continentCode();
                this.saveItem('continentCode', continent);
                return continent;
            }
            else {
                return false;
            }

        }
    }

};

function getSizeIdFromForm(id, productAttribute) {
    if (productAttribute) {
        let option = jQuery('#cart-form_' + id + ' #' + productAttribute).find(":selected");
        if (jQuery(option).length > 0) {
            return jQuery(option).val();
        }

    }

    return '';
}

function getSizeIdFromFormByProduct(product) {
    let result = '';

    if (product.sizes && product.sizes.length > 0) {
        let productAttribute = 'product_attribute_' + product.sizes[0].productAttribute.id;
        result = getSizeIdFromForm(product.id, productAttribute);

        if (result === '') {
            result = product.sizes[0].id.toString();
        }
    }

    return result;

}

function isMobileWidth() {
    return $(window).width() <= 640;
}

var clearForMeToken = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI1ZjQzZGQzZjdjMzAxMzM2OWM4ODJlNTUiLCJjbGllbnRuYW1lIjoibWFyaW8gYmFkZXNjdSIsInVzZXJuYW1lIjoibWFyaW9iYWRlc2N1IiwicGFzc3dvcmQiOiIkMmEkMTAkSkRuS2p3LmFIZHpMb1RvWUVESjRrLnhlSGpJOGFyR1hVdWRWS1NZTjZGL1RwdG4ya2F2WmUiLCJlbWFpbCI6ImtyaXN0eW5hQG1hcmlvYmFkZXNjdS5jb20iLCJwYWNrYWdlIjoidWx0YSBjb25zY2lvdXMgYmVhdXR5IiwicGVybWlzc2lvbiI6Im93bmVyIiwiaWF0IjoxNjMyMjQ5NzgxfQ.M-fTXj-1jsU6RZ1_2y7twQndJ-TMYo8qrugA1hi86-o';
var clearForMeClientName = 'mario badescu';

function getIngredients(sku, callback) {
    //var bearerToken = clearForMeToken;
    //var sku = sku;
    //var clientName = clearForMeClientName;
    $.ajax({
        contentType: 'application/json',
        headers: {
            'Authorization': clearForMeToken
        },
        dataType: 'json',
        method: 'GET',
        url: 'https://server.clearforme.com/api/app/products/details?sku=' +
            sku + '&clientname=' + clearForMeClientName
    }).then(function (response) {
        console.log(response);
        if (callback) {
            callback(response);
        }

    });
}

function getIngredientInfo(sku, name, callback) {
    $.ajax({
        contentType: 'application/json',
        headers: {
            'Authorization': clearForMeToken
        },
        dataType: 'json',
        method: 'GET',
        url:
            'https://server.clearforme.com/api/app/ingredients/definition?sku=' + sku +
            '&ingredientName=' + name + '&clientname=' + clearForMeClientName
    }).then(function (response) {
        callback(name, response);

    }).catch(function (response) {

    });
}
